import React from "react";

export default function Footer() {
  return (
    <footer className="site-footer">

      {/* HOSPITALS */}
      <div className="footer-locations-row">

        <div className="footer-loc-card">
          <div className="footer-loc-header">
            <div className="footer-loc-pin-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#C9A84C"/>
                <circle cx="12" cy="9" r="2.5" fill="#fff"/>
              </svg>
            </div>
            <div>
              <div className="footer-loc-name">Medicover Hospitals</div>
              <div className="footer-loc-area">Hitec City, Hyderabad</div>
            </div>
          </div>
          <div className="footer-loc-addr">
            Room No.2, Dept. of Orthopaedics, OPD Block,<br/>
            Opp. Cyber Gateway, Hitec City
          </div>
          <div className="footer-loc-meta">
            <span className="footer-loc-meta-label">Timings</span>
            <span className="footer-loc-meta-value">11 AM – 3 PM</span>
          </div>
          <div className="footer-loc-meta">
            <span className="footer-loc-meta-label">Contact</span>
            <a href="tel:04068334455" className="footer-loc-link">040-6833 4455</a>
          </div>
        </div>

        <div className="footer-loc-card">
          <div className="footer-loc-header">
            <div className="footer-loc-pin-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#C9A84C"/>
                <circle cx="12" cy="9" r="2.5" fill="#fff"/>
              </svg>
            </div>
            <div>
              <div className="footer-loc-name">Agastya Hospitals</div>
              <div className="footer-loc-area">L.B. Nagar, Hyderabad</div>
            </div>
          </div>
          <div className="footer-loc-addr">
            Nagarjuna Sagar Road, Hastinapuram,<br/>
            L.B. Nagar, Hyderabad
          </div>
          <div className="footer-loc-meta">
            <span className="footer-loc-meta-label">Booking</span>
            <span className="footer-loc-meta-value">By prior appointment</span>
          </div>
          <div className="footer-loc-meta">
            <span className="footer-loc-meta-label">Contact</span>
            <a href="tel:+919459108108" className="footer-loc-link">+91 94591 08108</a>
          </div>
        </div>

      </div>

      {/* MAIN GRID */}
      <div className="footer-main-grid">

        <div>
          <h3 className="footer-brand-title">Hand & Wrist Surgery</h3>
          <div className="footer-brand-sub">Dr. Suneel · Hyderabad</div>
        </div>

        <div>
          <div className="footer-col-label">NAVIGATE</div>
          <div className="footer-nav-links">
            {[
              { label: "About",            href: "/about" },
              { label: "Services",         href: "/services" },
              { label: "Events & Articles", href: "/events-articles" },
              { label: "Gallery",          href: "/gallery" },
              { label: "Testimonials",     href: "/testimonials" },
              { label: "Contact",          href: "/contact" },
            ].map((item, i) => (
              <a key={i} href={item.href} className="footer-nav-link">{item.label}</a>
            ))}
          </div>
        </div>

        <div>
          <div className="footer-col-label">GET IN TOUCH</div>
          <div className="footer-contact-row-item">
            <a href="tel:+919573152875" className="footer-contact-link">+91 9573152875</a>
          </div>
          <div className="footer-contact-row-item">
            <a href="mailto:handandwristclinics@gmail.com" className="footer-contact-link">handandwristclinics@gmail.com</a>
          </div>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom-bar">
        <div>© 2026 Hand & Wrist Surgery, Hyderabad. All rights reserved.</div>
        <div className="footer-legal-links">
          <a href="/privacy-policy" style={{color:"inherit",textDecoration:"none"}}>Privacy Policy</a>
          <a href="/terms" style={{color:"inherit",textDecoration:"none"}}>Terms</a>
        </div>
      </div>

    </footer>
  );
}